import { AnyNode, AtRule, Declaration, Root, Rule } from 'postcss';

class CssItem {
  node: AnyNode = null;
  parent: CssItem = null;
}

class CssStylesheet extends CssItem {
  path: string = null;
  root: CssRoot = null;
  isFactory: boolean = false;
}

class CssRoot extends CssItem {
  node: Root = null;
  parent: CssStylesheet = null;
  items: CssItem[] = [];
}

class CssMedium extends CssItem {
  node: AtRule = null;
  parent: CssRoot = null;
  items: CssItem[] = [];

  get params(): string {
    return this.node?.params || null;
  }

  toString(): string {
    return `@media ${this.node.params}`;
  }
}

class CssRule extends CssItem {
  node: Rule = null;
  parent: CssRoot | CssMedium = null;
  items: CssItem[] = [];

  selector: string = null;

  get comment(): string {
    const nodeBetween = this.node?.raws?.between || '';
    const match = nodeBetween.match(/\/\*([\s\S]*?)\*\//);
    if (match)
      return match[0].trim();
    return null;
  }

  toString(): string {
    return this.selector;
  }
}

class CssProperty extends CssItem {
  node: Declaration = null;
  parent: CssRule = null;

  private _name: string;

  get name(): string {
    return this._name === undefined
      ? this.node?.prop || null
      : this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get important(): boolean {
    return this.node.important;
  }

  toString(): string {
    return `${this.name}: ${this.node?.value}${this.important ? ' !important' : ''};`;
  }

  clone(): CssProperty {
    const cloned = new CssProperty();
    cloned.node = this.node;
    cloned.parent = this.parent;
    cloned._name = this.name;
    return cloned;
  }
}

export { CssItem, CssMedium, CssProperty, CssRoot, CssRule, CssStylesheet };

